import {
  GetTranscriptionLanguage,
  HasOptedOutOfTranscription
} from 'plugin/src/shared/Settings'
import { getTZOffset } from 'plugin/src/shared/Utils'
import { getBasicClassroomInfo } from 'plugin/src/shared/classroom/classroomInfo'
import { isMoteForSlidesActive } from 'plugin/src/widget/slides/helpers'
import {
  getContainingUrlFromActiveTab,
  getExtensionVersion,
  isInExtension
} from '@mote/helpers/extension'
import { useGenericRequestHandler } from '../../../handlers/useGenericRequestHandler'

/**
 * @param {string|null} parentMoteId
 * @param {boolean} shouldRedirect
 */
export function useMoteRegisterMutation(parentMoteId, shouldRedirect) {
  const json = {
    containingURL: window.location.href,
    TZOffset: getTZOffset()
  }

  if (parentMoteId) {
    json.parentMoteId = parentMoteId
  }

  if (isInExtension()) {
    json.clientVersion = `extension:${getExtensionVersion()}`
    json.shouldRedirect = shouldRedirect
  }

  const genericRequestHandler = useGenericRequestHandler({
    route: `v1/m/register`,
    method: 'POST'
  })

  function handleMutation(payload) {
    const variables = {
      ...payload.variables,
      ...json
    }

    return injectDynamicPayload(variables).then(finalVariables =>
      genericRequestHandler.mutate({
        ...payload,
        variables: finalVariables
      })
    )
  }

  return { ...genericRequestHandler, mutate: handleMutation }
}

async function injectDynamicPayload(payload = {}) {
  const json = { ...payload }

  if (isInExtension()) {
    json.containingURL = await getContainingUrlFromActiveTab()
    json.transcriptionOptOut = HasOptedOutOfTranscription()
    json.transcriptionLanguage = GetTranscriptionLanguage()
    json.googleSlidesInsertMode = isMoteForSlidesActive()

    const classroomData = getBasicClassroomInfo()
    for (const classroomProperty in classroomData) {
      json[classroomProperty] = classroomData[classroomProperty]
    }
  }

  return json
}
